import api from '../../api/client';
import React from "react";
import { Card, Tabs } from "antd";
import Departments from "./Departments";
import Positions from "./Positions";

const { TabPane } = Tabs;

const HRManagement = () => {
  return (
    <Card title="Departments Management">
      <Tabs defaultActiveKey="departments">
        <TabPane tab="Departments" key="departments">
          <Departments />
        </TabPane>
        <TabPane tab="Positions" key="positions">
          <Positions />
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default HRManagement;
